
import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);
// Vue.config.devtools = true;

export default new VueRouter({
	mode: 'history',
	scrollBehavior(to, from, savedPos)
	{
		if (savedPos)
			return savedPos;
		else
			return { x: 0, y: 0 };
	}
});